import Vue from 'vue'
import Router from 'vue-router'
import List from "../components/user/List";
import Login from "../components/login/login";
import Register from "../components/login/Register";
import OrderList from "../components/order/OrderList";
import StatusList from "../components/status/StatusList";
Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/',
      redirect:'/login'
    },
    {
      path:'/login',
      component:Login,
    },
    {
      path:'/orders',
      component: OrderList,
    },
    {
      path:'/status',
      component: StatusList,
    },
    {
      path: '/register',
      component:Register
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js